
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fFLlQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3f98f6e796d374$export$2e2bcd8739ae039);

var $dSPi7 = parcelRequire("dSPi7");

var $be3f98f6e796d374$export$2e2bcd8739ae039 = (0, $dSPi7.Client);

});
parcelRegister("dSPi7", function(module, exports) {

$parcel$export(module.exports, "Client", () => $493ff52ba08ef08e$export$1f2bb630327ac4b6);

var $7n9mn = parcelRequire("7n9mn");

var $lIE6R = parcelRequire("lIE6R");

var $h9fJ0 = parcelRequire("h9fJ0");

var $i2hEG = parcelRequire("i2hEG");

var $iGLMW = parcelRequire("iGLMW");

var $ewcwE = parcelRequire("ewcwE");

var $9si8t = parcelRequire("9si8t");
const $493ff52ba08ef08e$var$PLATFORM = 'WEB';
const $493ff52ba08ef08e$var$version = "0.0.0-use.local";
const $493ff52ba08ef08e$export$a1cc5ecc39716e2b = 1000;
const $493ff52ba08ef08e$export$fc27646dc891c6e0 = 10;
const $493ff52ba08ef08e$var$SUBSCRIBE_DEBOUNCE_TIME_IN_MILLISECONDS = 10;
class $493ff52ba08ef08e$export$1f2bb630327ac4b6 {
    constructor(config, protocols){
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)({
            maxListeners: 500,
            wildcard: true,
            delimiter: ':'
        });
        this.currentChannels = new Set();
        this.capabilities = [];
        this.protocols = new Map();
        this.retryCount = 0;
        this.subscribeDebounced = null;
        this.subscribedToBaseEvents = false;
        this.subscribeBaseRequest = {
            clientInfo: {
                version: $493ff52ba08ef08e$var$version,
                platform: $493ff52ba08ef08e$var$PLATFORM,
                capabilities: this.capabilities
            }
        };
        this.onMessage = (event, data)=>{
            this.eventEmitter.emit(event, event, data);
        };
        this.onAccessDenied = ()=>{
            (0, $ewcwE.logDebug)('Access denied');
            if (this.retryCount > $493ff52ba08ef08e$export$fc27646dc891c6e0) {
                (0, $ewcwE.logError)('Retry count exceeded');
                return;
            }
            return new Promise((resolve, reject)=>{
                window.setTimeout(()=>{
                    this.subscribeToCurrentChannels().then(()=>resolve(this)).catch(reject);
                }, $493ff52ba08ef08e$export$a1cc5ecc39716e2b * 2 ** this.retryCount);
                this.retryCount++;
            });
        };
        this.onNetworkUp = ()=>{
            this.retryCount = 0;
            this.eventEmitter.emit((0, $lIE6R.SpecialEventType).CONNECTED);
        };
        this.onReconnect = ()=>{
            this.eventEmitter.emit((0, $lIE6R.SpecialEventType).RECONNECT);
        };
        this.config = config;
        if (!protocols) {
            protocols = [];
            if (config.apsProtocol?.enabled) protocols.push(new (0, $iGLMW.default)(config.apsProtocol?.url, config.apsProtocol?.preferredTransport, config.apsProtocol?.skipFallback, config.analyticsClient));
        }
        this.subscribeBaseRequest.clientInfo.capabilities = this.registerProtocols(protocols);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
        return this;
    }
    off(event, listener) {
        this.eventEmitter.removeListener(event, listener);
        return this;
    }
    join(aris) {
        let channelsChanged = false;
        aris.forEach((ari)=>{
            if (!this.currentChannels.has(ari)) {
                this.currentChannels.add(ari);
                channelsChanged = true;
            }
        });
        if (channelsChanged) return this.debouncedSubscribeToCurrentChannels();
        return Promise.resolve(this);
    }
    leave(aris) {
        let channelsChanged = false;
        aris.forEach((ari)=>{
            if (this.currentChannels.has(ari)) {
                this.currentChannels.delete(ari);
                channelsChanged = true;
            }
        });
        if (channelsChanged) return this.debouncedSubscribeToCurrentChannels();
        return Promise.resolve(this);
    }
    networkUp() {
        this.retryCount = 0;
        if (this.currentProtocol) this.currentProtocol.networkUp();
    }
    networkDown() {
        if (this.currentProtocol) this.currentProtocol.networkDown();
    }
    debouncedSubscribeToCurrentChannels() {
        return new Promise((resolve, reject)=>{
            if (this.subscribeDebounced) window.clearTimeout(this.subscribeDebounced);
            this.subscribeDebounced = window.setTimeout(()=>{
                this.subscribeToCurrentChannels().then(()=>resolve(this)).catch(reject);
            }, $493ff52ba08ef08e$var$SUBSCRIBE_DEBOUNCE_TIME_IN_MILLISECONDS);
        });
    }
    registerProtocols(protocols) {
        let capabilities = [];
        protocols.forEach((protocol)=>{
            this.protocols.set(protocol.getType(), protocol);
            capabilities = capabilities.concat(protocol.getCapabilities());
        });
        return capabilities;
    }
    subscribeToCurrentChannels() {
        const channels = Array.from(this.currentChannels.values());
        if (channels.length === 0) {
            this.currentProtocol = undefined;
            this.protocols.forEach((protocol)=>protocol.unsubscribeAll());
            this.eventEmitter.removeAllListeners();
            this.subscribedToBaseEvents = false;
            return Promise.resolve();
        } else if (!this.subscribedToBaseEvents) {
            this.protocols.forEach((protocol)=>{
                protocol.on((0, $h9fJ0.EventType).MESSAGE, this.onMessage);
                protocol.on((0, $h9fJ0.EventType).ACCESS_DENIED, this.onAccessDenied);
                protocol.on((0, $h9fJ0.EventType).NETWORK_UP, this.onNetworkUp);
                protocol.on((0, $h9fJ0.EventType).RECONNECT, this.onReconnect);
            });
            this.subscribedToBaseEvents = true;
        }
        return this.fetchSubscribeProtocol(channels).then((subscribeProtocol)=>{
            const protocolConfig = subscribeProtocol.protocol;
            if (!protocolConfig) {
                (0, $ewcwE.logError)('Failed to retrieve subscription configuration', subscribeProtocol.errors);
                return;
            }
            this.currentProtocol = this.protocols.get(protocolConfig.type);
            if (!this.currentProtocol) {
                (0, $ewcwE.logInfo)(`Unknown protocol ${protocolConfig.type}, using noop one.`);
                this.currentProtocol = new (0, $i2hEG.default)();
            }
            this.currentProtocol.subscribe(protocolConfig);
        });
    }
    fetchSubscribeProtocol(aris) {
        return (0, $9si8t.utils).requestService(this.config, {
            path: 'subscribe',
            requestInit: {
                method: 'POST',
                body: JSON.stringify({
                    ...this.subscribeBaseRequest,
                    product: this.config.product,
                    channels: aris
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        }).then((data)=>{
            return data;
        });
    }
}

});
parcelRegister("lIE6R", function(module, exports) {

$parcel$export(module.exports, "SpecialEventType", () => $4e75aed5dc941f17$export$6221d17ecafe3bf9);
$parcel$export(module.exports, "APSTransportType", () => $4e75aed5dc941f17$export$2103d8d1743deded);
var $4e75aed5dc941f17$export$6221d17ecafe3bf9 = /*#__PURE__*/ function(SpecialEventType) {
    SpecialEventType["ERROR"] = "ERROR";
    SpecialEventType["CONNECTED"] = "CONNECTED";
    SpecialEventType["RECONNECT"] = "RECONNECT";
    return SpecialEventType;
}({});
var $4e75aed5dc941f17$export$2103d8d1743deded = /*#__PURE__*/ function(APSTransportType) {
    APSTransportType["HTTP"] = "HTTP";
    APSTransportType["WEBSOCKET"] = "WEBSOCKET";
    return APSTransportType;
}({});

});

parcelRegister("h9fJ0", function(module, exports) {

$parcel$export(module.exports, "EventType", () => $7bd563053f7f77fc$export$3d7865934588d77e);
var $7bd563053f7f77fc$export$3d7865934588d77e = /*#__PURE__*/ function(EventType) {
    EventType["MESSAGE"] = "MESSAGE";
    EventType["CONNECTED"] = "CONNECTED";
    EventType["ACCESS_DENIED"] = "ACCESS_DENIED";
    EventType["NETWORK_DOWN"] = "NETWORK_DOWN";
    EventType["NETWORK_UP"] = "NETWORK_UP";
    EventType["RECONNECT"] = "RECONNECT";
    return EventType;
}({});

});

parcelRegister("i2hEG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f985f9cdfc42c1a$export$2e2bcd8739ae039);
class $5f985f9cdfc42c1a$export$2e2bcd8739ae039 {
    getType() {
        return 'noop';
    }
    subscribe(_) {}
    unsubscribeAll() {}
    getCapabilities() {
        return [];
    }
    on(_event, _handler) {}
    off(_event, _handler) {}
    networkUp() {}
    networkDown() {}
}

});

parcelRegister("iGLMW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0776db902a4372ce$export$2e2bcd8739ae039);

var $lIE6R = parcelRequire("lIE6R");

var $7n9mn = parcelRequire("7n9mn");

var $ewcwE = parcelRequire("ewcwE");

var $faKJ0 = parcelRequire("faKJ0");

var $bolIt = parcelRequire("bolIt");

var $5JoWI = parcelRequire("5JoWI");

var $dcy9y = parcelRequire("dcy9y");
class $0776db902a4372ce$export$2e2bcd8739ae039 {
    /**
	 * @param apsUrl the URL used to initiate a Web Socket connection with Atlassian PubSub.
	 * Defaults to the path '/gateway/wss/fps', relative to the domain of the current window.location.
	 * @param preferredTransport indicates which type of transport the APS client should use. The default
	 * value is WEBSOCKET.
	 * @param skipFallback indicates that this class should not attempt to reconnected using the fallback transport
	 * in case the primary one fails. This value should, most of the time, be 'false' on a real client.
	 * @param analyticsWebClient a GasV3 AnalyticsWebClient instance which will be used to emit operational events
	 */ constructor(apsUrl = $0776db902a4372ce$export$2e2bcd8739ae039.getDefaultUrl(), preferredTransport = (0, $lIE6R.APSTransportType).WEBSOCKET, skipFallback = false, analyticsWebClient){
        this.url = apsUrl;
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
        this.skipFallback = skipFallback;
        this.analyticsClient = (0, $dcy9y.default)(analyticsWebClient);
        const transportParams = {
            url: this.url,
            eventEmitter: this.eventEmitter,
            analyticsClient: this.analyticsClient
        };
        const paramsActive = {
            ...transportParams,
            isFallback: false
        };
        const paramsFallback = {
            ...transportParams,
            isFallback: true
        };
        if (preferredTransport === (0, $lIE6R.APSTransportType).WEBSOCKET) {
            this.activeTransport = new (0, $5JoWI.default)(paramsActive);
            this.fallbackTransport = new (0, $faKJ0.default)(paramsFallback);
        } else {
            this.activeTransport = new (0, $faKJ0.default)(paramsActive);
            this.fallbackTransport = new (0, $5JoWI.default)(paramsFallback);
        }
    }
    static{
        this.getDefaultUrl = ()=>{
            return new URL((0, $bolIt.APS_STARGATE_PATH), window.location.origin);
        };
    }
    getCapabilities() {
        return [
            'APS'
        ];
    }
    getType() {
        return 'aps';
    }
    /**
	 * The APS protocol does not implement 'networkDown' or 'networkUp'.
	 * These functions are never called by our primary consumers.
	 */ networkDown() {
        (0, $ewcwE.logInfo)("the 'networkDown()' method is not supported by the APS protocol");
    }
    /**
	 * The APS protocol does not implement 'networkDown' or 'networkUp'.
	 * These functions are never called by our primary consumers.
	 */ networkUp() {
        (0, $ewcwE.logInfo)("the 'networkUp()' method is not supported by the APS protocol");
    }
    off(event, handler) {
        this.eventEmitter.off(event, handler);
    }
    on(event, handler) {
        this.eventEmitter.on(event, handler);
    }
    subscribe(config) {
        this.activeTransport.subscribe(new Set(config.channels)).catch((errorPrimary)=>{
            (0, $ewcwE.logDebug)(`Could not subscribe using primary transport: ${this.activeTransport.transportType()}. Will fallback? ${!this.skipFallback}`, errorPrimary);
            if (this.skipFallback) (0, $ewcwE.logDebug)('Skipping subscription fallback');
            else {
                this.analyticsClient.sendEvent('aps-protocol', 'falling back');
                this.activeTransport = this.fallbackTransport;
                (0, $ewcwE.logDebug)(`Retrying with fallback transport: ${this.fallbackTransport.transportType()}`);
                this.activeTransport.subscribe(new Set(config.channels)).catch((errorFallback)=>{
                    // should not happen, since we retry forever
                    this.analyticsClient.sendEvent('aps-protocol', 'fall back failed', {
                        error: errorFallback.message || 'Unknown error'
                    });
                });
            }
        });
    }
    unsubscribeAll() {
        this.eventEmitter.removeAllListeners();
        this.activeTransport.close();
    }
}

});
parcelRegister("ewcwE", function(module, exports) {

$parcel$export(module.exports, "logDebug", () => $a36ec98a77fb14e3$export$4cdc8edb1e3c510c);
$parcel$export(module.exports, "logInfo", () => $a36ec98a77fb14e3$export$89c0607256d35f0a);
$parcel$export(module.exports, "logError", () => $a36ec98a77fb14e3$export$58da9968c3170cb1);
let $a36ec98a77fb14e3$var$debugEnabled = false;
let $a36ec98a77fb14e3$var$stacktracesEnabled = false;
const $a36ec98a77fb14e3$var$LOG_PREFIX = '[Frontend PubSub] ';
function $a36ec98a77fb14e3$export$748ada60eaf985cc(enable) {
    $a36ec98a77fb14e3$var$debugEnabled = enable;
}
function $a36ec98a77fb14e3$export$4f7017086af31c25(enable) {
    $a36ec98a77fb14e3$var$stacktracesEnabled = enable;
}
function $a36ec98a77fb14e3$export$2a858f450a2f66d() {
    if ($a36ec98a77fb14e3$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $a36ec98a77fb14e3$export$4cdc8edb1e3c510c(msg, ...args) {
    if ($a36ec98a77fb14e3$var$debugEnabled) // eslint-disable-next-line no-console
    console.log($a36ec98a77fb14e3$var$LOG_PREFIX + msg, ...args);
}
function $a36ec98a77fb14e3$export$89c0607256d35f0a(msg, ...args) {
    // eslint-disable-next-line no-console
    console.info($a36ec98a77fb14e3$var$LOG_PREFIX + msg, ...args);
}
function $a36ec98a77fb14e3$export$58da9968c3170cb1(msg, ...args) {
    // eslint-disable-next-line no-console
    console.error($a36ec98a77fb14e3$var$LOG_PREFIX + msg, ...args);
}

});

parcelRegister("faKJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f7d65b30d82cdce$export$2e2bcd8739ae039);

var $h9fJ0 = parcelRequire("h9fJ0");

var $ewcwE = parcelRequire("ewcwE");

var $lIE6R = parcelRequire("lIE6R");

var $bolIt = parcelRequire("bolIt");

var $c1BuE = parcelRequire("c1BuE");
class $2f7d65b30d82cdce$export$2e2bcd8739ae039 extends (0, $c1BuE.default) {
    static{
        this.MSG_BOUNDARY = '\n';
    }
    static{
        this.PARAM_SUBSCRIBE_TO_CHANNELS = 'subscribeToChannels';
    }
    static{
        this.PARAM_REPLAY_FROM = 'replayFrom';
    }
    constructor(params){
        super(params), this.networkUp = false, this.abortController = null, this.isHidden = false, this.visibilityChangeListener = this.onVisibilityChange.bind(this);
    }
    transportType() {
        return (0, $lIE6R.APSTransportType).HTTP;
    }
    onVisibilityChange() {
        this.isHidden = document.visibilityState === 'hidden';
    }
    subscribe(channels) {
        if (channels == null || channels.size === 0) {
            (0, $ewcwE.logDebug)('channel list is null or empty. HTTP request is not going to be sent.');
            return Promise.resolve();
        }
        const url = new URL(this.baseUrl);
        url.searchParams.set(// The list of channels to subscribe to is passed as a query parameter.
        $2f7d65b30d82cdce$export$2e2bcd8739ae039.PARAM_SUBSCRIBE_TO_CHANNELS, [
            ...channels
        ].join(','));
        if (this.abortController !== null) return this.connectWithBackoff(()=>this.reconnectWithNewSubscriptionSet(url));
        return this.connectWithBackoff(()=>this.makeHttpRequest(url));
    }
    close() {
        (0, $ewcwE.logDebug)('Connection was closed by client');
        this.networkUp = false;
        // @ts-ignore: not sure why typecheck doesn't allow me to pass a parameter here. https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort#syntax
        this.abortController?.abort('CLOSED_BY_CLIENT');
    }
    reconnectWithNewSubscriptionSet(url) {
        // @ts-ignore: not sure why typecheck doesn't allow me to pass a parameter here. https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort#syntax
        this.abortController.abort('NEW_SUBSCRIPTION_SET');
        return new Promise((resolve)=>{
            // puts the call to makeHttpRequest at the back of the execution queue,
            // so the error handler code triggered by aborting the request can execute first.
            setTimeout(()=>{
                resolve(this.makeHttpRequest(url));
            }, 0);
        });
    }
    reconnect(url) {
        if (this.abortController?.signal?.aborted) // if the request was aborted, we don't reconnect.
        return Promise.resolve();
        if (this.lastSeenSequenceNumber) // Apply the "replay" mechanism to the request. This will ensure that, as soon as the connection is established,
        // APS will deliver all messages that were emitted in the time between when the previous request was closed (due
        // to time out) and the time the new request is successfully established.
        url.searchParams.set($2f7d65b30d82cdce$export$2e2bcd8739ae039.PARAM_REPLAY_FROM, this.lastSeenSequenceNumber.toString());
        return this.makeHttpRequest(url);
    }
    async makeHttpRequest(urlWithParams) {
        // AbortController allows us to abort the HTTP request - in case the "close" function is called, or the list of
        // subscribed channels change.
        document.addEventListener('visibilitychange', this.visibilityChangeListener);
        this.abortController = new AbortController();
        // @ts-ignore "fetch" should be able to take a URL as parameter. https://developer.mozilla.org/en-US/docs/Web/API/fetch#parameters
        const response = await fetch(urlWithParams, {
            signal: this.abortController?.signal
        });
        this.onFetchSuccessful(response);
        try {
            await this.processResponse(response);
        } catch (error) {
            if (!this.isAbortError(error)) {
                this.analyticsClient.sendEvent('aps-http', 'reconnecting');
                return this.reconnectWithBackoff(this.isHidden, ()=>this.reconnect(urlWithParams));
            }
        }
    }
    onFetchSuccessful(response) {
        if (!this.networkUp) {
            this.networkUp = true;
            // Emit the "NETWORK_UP" event only when the first request is completed. This ensures that the event
            // is not sent on reconnects that happen due to natural timeout.
            this.eventEmitter.emit((0, $h9fJ0.EventType).NETWORK_UP, {});
        }
        this.lastSeenSequenceNumber = (0, $bolIt.getTimestampBasedSequenceNumber)();
        return response;
    }
    isAbortError(error) {
        if (error.name === 'AbortError') {
            (0, $ewcwE.logDebug)('Request was intentionally aborted. Reason: ' + // @ts-ignore AbortSignal does contain a property called "reason". https://developer.mozilla.org/en-US/docs/Web/API/AbortSignal/reason
            this.abortController?.signal?.reason);
            return true;
        }
        return false;
    }
    emitMessage(sanitizedChunk) {
        const messageData = JSON.parse(sanitizedChunk);
        this.lastSeenSequenceNumber = messageData.sequenceNumber || null;
        this.eventEmitter.emit((0, $h9fJ0.EventType).MESSAGE, messageData.type, messageData.payload);
    }
    async processResponse(response) {
        // Read the contents of the response using a "reader", so the chunks can be consumed as soon as they're received,
        // in other words, we don't need to wait for the request to be completed (which can take a long time) to process
        // response contents.
        const reader = response?.body?.getReader();
        if (reader === null || reader === undefined) {
            this.analyticsClient.sendEvent('aps-http', 'null response');
            (0, $ewcwE.logDebug)('Response body from APS request was null');
            return;
        }
        const decoder = new TextDecoder();
        const consumeChunk = (result)=>{
            const chunk = decoder.decode(result.value || new Uint8Array(), {
                stream: !result.done
            });
            chunk// Multiple messages can be delivered in the same chunk, so we split the chunk using the boundary character(s)
            .split($2f7d65b30d82cdce$export$2e2bcd8739ae039.MSG_BOUNDARY).filter((chunkPart)=>chunkPart.trim() !== '').forEach((sanitizedChunk)=>this.emitMessage(sanitizedChunk));
            if (result.done) return;
            else return readChunk();
        };
        const readChunk = async ()=>{
            const chunk = await reader.read();
            return consumeChunk(chunk);
        };
        return readChunk();
    }
}

});
parcelRegister("bolIt", function(module, exports) {

$parcel$export(module.exports, "APS_STARGATE_PATH", () => $d94a6089f3b18633$export$8affde3f03b7d8fb);
$parcel$export(module.exports, "reconnectBackoffOptions", () => $d94a6089f3b18633$export$bda402bf18c1d4b0);
$parcel$export(module.exports, "firstConnectBackoffOptions", () => $d94a6089f3b18633$export$92d03939bb475e59);
$parcel$export(module.exports, "getTimestampBasedSequenceNumber", () => $d94a6089f3b18633$export$ed5ea3826f96c187);

var $khO3w = parcelRequire("khO3w");
const $d94a6089f3b18633$export$8affde3f03b7d8fb = '/gateway/wss/fps';
const $d94a6089f3b18633$export$bda402bf18c1d4b0 = (isHidden)=>{
    return {
        delayFirstAttempt: true,
        startingDelay: $d94a6089f3b18633$export$32bac9bcf9e91395(isHidden) ? 5000 + Math.random() * 300000 : 500 + Math.random() * 180000,
        timeMultiple: 2,
        numOfAttempts: 5,
        maxDelay: 300000
    };
};
const $d94a6089f3b18633$export$92d03939bb475e59 = (isFallback)=>{
    return {
        delayFirstAttempt: (0, $khO3w.fg)('platform-delay-retries-on-first-connect-fps'),
        startingDelay: (0, $khO3w.fg)('platform-delay-retries-on-first-connect-fps') ? 500 + Math.random() * 180000 : 200,
        timeMultiple: 2,
        numOfAttempts: isFallback ? 5 : 3,
        maxDelay: 600000
    };
};
const $d94a6089f3b18633$export$ed5ea3826f96c187 = ()=>{
    return Math.floor(new Date().getTime() / 1000); // timestamp in seconds
};
const $d94a6089f3b18633$export$32bac9bcf9e91395 = (isHidden)=>{
    return isHidden && (0, $khO3w.fg)('platform-delay-retries-for-clients-on-fps');
};

});

parcelRegister("c1BuE", function(module, exports) {

$parcel$export(module.exports, "default", () => $75f77e943da4ba58$export$2e2bcd8739ae039);

var $bolIt = parcelRequire("bolIt");

var $bsyZ4 = parcelRequire("bsyZ4");
class $75f77e943da4ba58$export$2e2bcd8739ae039 {
    constructor(params){
        this.lastSeenSequenceNumber = null;
        this.baseUrl = params.url;
        this.eventEmitter = params.eventEmitter;
        this.analyticsClient = params.analyticsClient;
        this.isFallback = params.isFallback;
    }
    async connectWithBackoff(connectFn) {
        return (0, $bsyZ4.backOff)(connectFn, {
            ...(0, $bolIt.firstConnectBackoffOptions)(this.isFallback),
            retry: (e, count)=>{
                this.analyticsClient.sendEvent(this.analyticsSubject(), 'retrying connect', {
                    errorMessage: e?.message || 'unknown',
                    count: count
                });
                return true;
            }
        });
    }
    async reconnectWithBackoff(isHidden, reconnectFn) {
        if (!this.lastSeenSequenceNumber) // will replay messages that were supposed to be received while we were retrying
        this.lastSeenSequenceNumber = (0, $bolIt.getTimestampBasedSequenceNumber)();
        return (0, $bsyZ4.backOff)(reconnectFn, {
            ...(0, $bolIt.reconnectBackoffOptions)(isHidden),
            retry: (e, count)=>{
                this.analyticsClient.sendEvent(this.analyticsSubject(), 'retrying reconnect', {
                    errorMessage: e?.message || 'unknown',
                    count: count
                });
                return true;
            }
        });
    }
    analyticsSubject() {
        return `aps-${this.transportType()}`.toLowerCase();
    }
}

});
parcelRegister("bsyZ4", function(module, exports) {
"use strict";
var $857d72506b725747$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $857d72506b725747$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ZQen = parcelRequire("4ZQen");

var $8MvwP = parcelRequire("8MvwP");
function $857d72506b725747$var$backOff(request, options) {
    if (options === void 0) options = {};
    return $857d72506b725747$var$__awaiter(this, void 0, void 0, function() {
        var sanitizedOptions, backOff;
        return $857d72506b725747$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    sanitizedOptions = $4ZQen.getSanitizedOptions(options);
                    backOff = new $857d72506b725747$var$BackOff(request, sanitizedOptions);
                    return [
                        4 /*yield*/ ,
                        backOff.execute()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
            }
        });
    });
}
module.exports.backOff = $857d72506b725747$var$backOff;
var $857d72506b725747$var$BackOff = /** @class */ function() {
    function BackOff(request, options) {
        this.request = request;
        this.options = options;
        this.attemptNumber = 0;
    }
    BackOff.prototype.execute = function() {
        return $857d72506b725747$var$__awaiter(this, void 0, void 0, function() {
            var e_1, shouldRetry;
            return $857d72506b725747$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.attemptLimitReached) return [
                            3 /*break*/ ,
                            7
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.applyDelay()
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.request()
                        ];
                    case 3:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 4:
                        e_1 = _a.sent();
                        this.attemptNumber++;
                        return [
                            4 /*yield*/ ,
                            this.options.retry(e_1, this.attemptNumber)
                        ];
                    case 5:
                        shouldRetry = _a.sent();
                        if (!shouldRetry || this.attemptLimitReached) throw e_1;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            0
                        ];
                    case 7:
                        throw new Error("Something went wrong.");
                }
            });
        });
    };
    Object.defineProperty(BackOff.prototype, "attemptLimitReached", {
        get: function() {
            return this.attemptNumber >= this.options.numOfAttempts;
        },
        enumerable: true,
        configurable: true
    });
    BackOff.prototype.applyDelay = function() {
        return $857d72506b725747$var$__awaiter(this, void 0, void 0, function() {
            var delay;
            return $857d72506b725747$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        delay = $8MvwP.DelayFactory(this.options, this.attemptNumber);
                        return [
                            4 /*yield*/ ,
                            delay.apply()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return BackOff;
}();

});
parcelRegister("4ZQen", function(module, exports) {
"use strict";
var $3a355fe7b971a54e$var$__assign = module.exports && module.exports.__assign || function() {
    $3a355fe7b971a54e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3a355fe7b971a54e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3a355fe7b971a54e$var$defaultOptions = {
    delayFirstAttempt: false,
    jitter: "none",
    maxDelay: Infinity,
    numOfAttempts: 10,
    retry: function() {
        return true;
    },
    startingDelay: 100,
    timeMultiple: 2
};
function $3a355fe7b971a54e$var$getSanitizedOptions(options) {
    var sanitized = $3a355fe7b971a54e$var$__assign($3a355fe7b971a54e$var$__assign({}, $3a355fe7b971a54e$var$defaultOptions), options);
    if (sanitized.numOfAttempts < 1) sanitized.numOfAttempts = 1;
    return sanitized;
}
module.exports.getSanitizedOptions = $3a355fe7b971a54e$var$getSanitizedOptions;

});

parcelRegister("8MvwP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6KTRA = parcelRequire("6KTRA");

var $iGgXu = parcelRequire("iGgXu");
function $664b435844906bbd$var$DelayFactory(options, attempt) {
    var delay = $664b435844906bbd$var$initDelayClass(options);
    delay.setAttemptNumber(attempt);
    return delay;
}
module.exports.DelayFactory = $664b435844906bbd$var$DelayFactory;
function $664b435844906bbd$var$initDelayClass(options) {
    if (!options.delayFirstAttempt) return new $6KTRA.SkipFirstDelay(options);
    return new $iGgXu.AlwaysDelay(options);
}

});
parcelRegister("6KTRA", function(module, exports) {
"use strict";
var $4eb25f42819b59e4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $4eb25f42819b59e4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4eb25f42819b59e4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6mSOH = parcelRequire("6mSOH");
var $4eb25f42819b59e4$var$SkipFirstDelay = /** @class */ function(_super) {
    $4eb25f42819b59e4$var$__extends(SkipFirstDelay, _super);
    function SkipFirstDelay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SkipFirstDelay.prototype.apply = function() {
        return $4eb25f42819b59e4$var$__awaiter(this, void 0, void 0, function() {
            return $4eb25f42819b59e4$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.isFirstAttempt ? true : _super.prototype.apply.call(this)
                ];
            });
        });
    };
    Object.defineProperty(SkipFirstDelay.prototype, "isFirstAttempt", {
        get: function() {
            return this.attempt === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SkipFirstDelay.prototype, "numOfDelayedAttempts", {
        get: function() {
            return this.attempt - 1;
        },
        enumerable: true,
        configurable: true
    });
    return SkipFirstDelay;
}($6mSOH.Delay);
module.exports.SkipFirstDelay = $4eb25f42819b59e4$var$SkipFirstDelay;

});
parcelRegister("6mSOH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9vakh = parcelRequire("9vakh");
var $4a2f519b227db519$var$Delay = /** @class */ function() {
    function Delay(options) {
        this.options = options;
        this.attempt = 0;
    }
    Delay.prototype.apply = function() {
        var _this = this;
        return new Promise(function(resolve) {
            return setTimeout(resolve, _this.jitteredDelay);
        });
    };
    Delay.prototype.setAttemptNumber = function(attempt) {
        this.attempt = attempt;
    };
    Object.defineProperty(Delay.prototype, "jitteredDelay", {
        get: function() {
            var jitter = $9vakh.JitterFactory(this.options);
            return jitter(this.delay);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Delay.prototype, "delay", {
        get: function() {
            var constant = this.options.startingDelay;
            var base = this.options.timeMultiple;
            var power = this.numOfDelayedAttempts;
            var delay = constant * Math.pow(base, power);
            return Math.min(delay, this.options.maxDelay);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Delay.prototype, "numOfDelayedAttempts", {
        get: function() {
            return this.attempt;
        },
        enumerable: true,
        configurable: true
    });
    return Delay;
}();
module.exports.Delay = $4a2f519b227db519$var$Delay;

});
parcelRegister("9vakh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9wEeE = parcelRequire("9wEeE");

var $8O9KL = parcelRequire("8O9KL");
function $6eaf04d4b12660e6$var$JitterFactory(options) {
    switch(options.jitter){
        case "full":
            return $9wEeE.fullJitter;
        case "none":
        default:
            return $8O9KL.noJitter;
    }
}
module.exports.JitterFactory = $6eaf04d4b12660e6$var$JitterFactory;

});
parcelRegister("9wEeE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $6ef6501e3e7d7ad2$var$fullJitter(delay) {
    var jitteredDelay = Math.random() * delay;
    return Math.round(jitteredDelay);
}
module.exports.fullJitter = $6ef6501e3e7d7ad2$var$fullJitter;

});

parcelRegister("8O9KL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $669a8f034fa1d62b$var$noJitter(delay) {
    return delay;
}
module.exports.noJitter = $669a8f034fa1d62b$var$noJitter;

});




parcelRegister("iGgXu", function(module, exports) {
"use strict";
var $d9994ddab40dbabb$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6mSOH = parcelRequire("6mSOH");
var $d9994ddab40dbabb$var$AlwaysDelay = /** @class */ function(_super) {
    $d9994ddab40dbabb$var$__extends(AlwaysDelay, _super);
    function AlwaysDelay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AlwaysDelay;
}($6mSOH.Delay);
module.exports.AlwaysDelay = $d9994ddab40dbabb$var$AlwaysDelay;

});





parcelRegister("5JoWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea869071af3560f$export$2e2bcd8739ae039);

var $ewcwE = parcelRequire("ewcwE");

var $h9fJ0 = parcelRequire("h9fJ0");

var $hiepr = parcelRequire("hiepr");

var $lIE6R = parcelRequire("lIE6R");

var $bolIt = parcelRequire("bolIt");

var $c1BuE = parcelRequire("c1BuE");
var $0ea869071af3560f$var$State = /*#__PURE__*/ function(State) {
    State[State["CLOSED"] = 0] = "CLOSED";
    State[State["CONNECTING"] = 1] = "CONNECTING";
    State[State["OPEN"] = 2] = "OPEN";
    State[State["RECONNECTING"] = 3] = "RECONNECTING";
    return State;
}($0ea869071af3560f$var$State || {});
class $0ea869071af3560f$export$2e2bcd8739ae039 extends (0, $c1BuE.default) {
    constructor(params){
        super(params), this.activeChannels = new Set(), this.closedByClient = false, this.state = 0, this.isHidden = false, this.visibilityChangeListener = this.onVisibilityChange.bind(this);
        this.url = $0ea869071af3560f$export$2e2bcd8739ae039.toWssUrl(params.url);
    }
    transportType() {
        return (0, $lIE6R.APSTransportType).WEBSOCKET;
    }
    onVisibilityChange() {
        this.isHidden = document.visibilityState === 'hidden';
    }
    async initClient(channels) {
        document.addEventListener('visibilitychange', this.visibilityChangeListener);
        return new Promise((resolve, reject)=>{
            const ws = new (0, $hiepr.default)({
                url: this.url,
                onOpen: ()=>{
                    this.eventEmitter.emit((0, $h9fJ0.EventType).NETWORK_UP, {});
                    this.closedByClient = false;
                    ws.send({
                        type: 'subscribe',
                        channels: channels,
                        replayFrom: this.lastSeenSequenceNumber || undefined
                    });
                    this.lastSeenSequenceNumber = (0, $bolIt.getTimestampBasedSequenceNumber)();
                    resolve(ws);
                },
                onMessage: (event)=>{
                    const data = JSON.parse(event.data);
                    if (data.type === 'CHANNEL_ACCESS_DENIED') {
                        this.eventEmitter.emit((0, $h9fJ0.EventType).ACCESS_DENIED, data.payload);
                        return;
                    }
                    this.lastSeenSequenceNumber = data.sequenceNumber;
                    this.eventEmitter.emit((0, $h9fJ0.EventType).MESSAGE, data.type, data.payload);
                },
                onClose: (event)=>{
                    if (this.closedByClient) return;
                    this.eventEmitter.emit((0, $h9fJ0.EventType).NETWORK_DOWN, {});
                    if (this.state === 1 || this.state === 3) {
                        reject('connection closed');
                        return;
                    }
                    if (this.state === 2) this.reconnect([
                        ...this.activeChannels
                    ]).then((websocketClient)=>{
                        this.websocketClient = websocketClient;
                    }).catch(reject);
                },
                onMessageSendError: (readyState)=>{},
                onError: (event)=>{
                    (0, $ewcwE.logDebug)('Websocket onError', event);
                }
            });
        });
    }
    async connect(channels) {
        this.state = 1;
        return this.connectWithBackoff(async ()=>this.initClient(channels)).then((ws)=>{
            this.state = 2;
            return ws;
        });
    }
    async reconnect(channels) {
        this.state = 3;
        return this.reconnectWithBackoff(this.isHidden, async ()=>this.initClient(channels)).then((ws)=>{
            this.state = 2;
            return ws;
        });
    }
    async subscribe(channels) {
        const newChannels = [
            ...channels
        ].filter((channelName)=>!this.activeChannels.has(channelName));
        const removedChannels = [
            ...this.activeChannels
        ].filter((channelName)=>!channels.has(channelName));
        if (removedChannels.length === 0 && newChannels.length === 0) return Promise.resolve();
        newChannels.forEach((channel)=>this.activeChannels.add(channel));
        removedChannels.forEach((channel)=>this.activeChannels.delete(channel));
        if (!this.websocketClient) this.websocketClient = await this.connect(newChannels);
        else {
            if (newChannels.length > 0) await this.websocketClient?.send({
                type: 'subscribe',
                channels: Array.from(newChannels)
            });
            if (removedChannels.length > 0) await this.websocketClient?.send({
                type: 'unsubscribe',
                channels: Array.from(removedChannels)
            });
        }
    }
    close() {
        if (this.activeChannels.size > 0) {
            this.websocketClient?.send({
                type: 'unsubscribe',
                channels: Array.from(this.activeChannels)
            });
            this.activeChannels.clear();
        }
        this.closedByClient = true;
        this.lastSeenSequenceNumber = null;
        this.websocketClient?.close();
        this.websocketClient = undefined;
        this.state = 0;
    }
    static{
        this.toWssUrl = (apsUrl)=>{
            const wssUrl = new URL(apsUrl);
            wssUrl.protocol = 'wss';
            return wssUrl;
        };
    }
}

});
parcelRegister("hiepr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5999100c6c118dec$export$2e2bcd8739ae039);
const $5999100c6c118dec$var$noop = ()=>{};
class $5999100c6c118dec$export$2e2bcd8739ae039 {
    constructor(params){
        this.url = params.url;
        this.onMessageSendError = params.onMessageSendError || $5999100c6c118dec$var$noop;
        this.promise = this.initializeClient(params);
    }
    async initializeClient({ url: url, onMessage: onMessage = $5999100c6c118dec$var$noop, onClose: onClose = $5999100c6c118dec$var$noop, onOpen: onOpen = $5999100c6c118dec$var$noop, onError: onError = $5999100c6c118dec$var$noop }) {
        return new Promise((resolve, reject)=>{
            const websocket = new WebSocket(url.toString());
            websocket.addEventListener('open', (event)=>{
                onOpen(event);
                resolve(websocket);
            });
            websocket.addEventListener('message', (event)=>onMessage(event));
            websocket.addEventListener('error', (event)=>{
                onError(event);
            });
            websocket.addEventListener('close', (event)=>{
                onClose(event);
            });
        });
    }
    async send(message) {
        const websocket = await this.promise;
        if (websocket.readyState === WebSocket.OPEN) websocket.send(JSON.stringify(message));
        else this.onMessageSendError(websocket.readyState);
    }
    async close() {
        const websocket = await this.promise;
        if (websocket.readyState === WebSocket.OPEN || websocket.readyState === WebSocket.CONNECTING) websocket.close();
    }
}

});


parcelRegister("dcy9y", function(module, exports) {

$parcel$export(module.exports, "default", () => $542f5e7588331d6a$export$2e2bcd8739ae039);

var $ewcwE = parcelRequire("ewcwE");
var $542f5e7588331d6a$export$2e2bcd8739ae039 = (analyticsWebClient)=>{
    if (analyticsWebClient) return new $542f5e7588331d6a$var$DefaultAnalyticsClient(analyticsWebClient);
    return new $542f5e7588331d6a$var$MockAnalyticsClient();
};
class $542f5e7588331d6a$var$DefaultAnalyticsClient {
    constructor(analyticsWebClient){
        this.analyticsWebClient = analyticsWebClient;
    }
    sendEvent(subject, action, attributes) {
        this.analyticsWebClient.sendOperationalEvent({
            source: 'atlaskit/pubsub',
            action: action,
            actionSubject: subject,
            attributes: attributes
        });
    }
}
class $542f5e7588331d6a$var$MockAnalyticsClient {
    sendEvent(subject, action, attributes) {
        (0, $ewcwE.logDebug)('[Mock analytics client]', subject, action, attributes);
    }
}

});





//# sourceMappingURL=@atlaskit-jira_pubsub.af4a2206.js.map
